<template>
  <el-button type="primary" size="mini" plain @click="pushView">
    View
  </el-button>
</template>

<script>
export default {
  props: {
    article: Object,
  },

  methods: {
    pushView() {
      window.open(`${ process.env.VUE_APP_APP_HOST }/magazine/${ this.article.slug }~${ this.article.id }`)
    },
  },
}
</script>
